if (window.location.hostname === 'join.pdffund.com') {
  import('./dealer-onboarding/main.js').then(() => {
    document.getElementById('app-splash')?.remove()
    document.body.appendChild(document.createElement('dealer-onboarding-app'))
  })
} else {
  import('./index.js')
}
